<template>
  <div class="Gallery">
    <div id="tagFilterGroup">
      <span id="filterLabel">Filter by tags:</span>
      <b-form-tags input-id="filterTags-fld" v-model="searchFilter"></b-form-tags>
      <b-button variant="secondary" @click="filterIllustrations()">Filter</b-button>
    </div>
    <div id="photos">
      <b-container v-for="(image, i) in currIllustrations" :key="i">
        <b-img class="galleryImg" :src="image.link" v-b-modal="'modal-zoomImage'" fluid @click="setFocusedIllustration(image)"/>
      </b-container>
      <b-modal id="modal-zoomImage" body-class="zoomedModal"  :hide-footer=true :hide-header=true @hide="resetFocusedIllustration">
        <div class="zoomImgContainer">
        <b-img class="zoomedImg" :src="currFocus"/>
        </div>
        <span class="taglist">Tags: <span v-for="(tag, t) in currFocusTags" :key="t"><span v-if="t != 0">,</span>{{tag}}</span>
        </span>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { db } from '@/firebase/init'


export default {
  components: {
    
  },
  data(){
    return{
      lightGalleryIndex: null,
      illustrations: [],
      searchFilter: '',
      currFocus: '',
      currFocusTags: [],
      currIllustrations: [],
    }
  },

  methods: {
    getIllustrations(){
      var illustrations = []
      db.collection('illustrations')
      .get()
      .then( docs => {
        if(docs){
          // console.log(docs)
          docs.forEach((doc) =>{
              illustrations.push(doc.data())
          })
        }
      })
      .then(() => {
        if(illustrations.length == 0){
          // DISPLAY NO ILLUSTRATIONS
          // console.log('no illustrations')
        }
        else{
          this.illustrations = illustrations
          // console.log(this.illustrations)
          // this.illustrations.forEach(item => {console.log(item)})
          this.currIllustrations = this.illustrations;
          // console.log(this.currIllustrations);
        }
      })
    },

    // called when filter button is pressed, if not button then this method will be placed in 'computed'
    filterIllustrations(){
      if(this.searchFilter.length > 0){
      this.currIllustrations =  this.illustrations.filter((illustration) =>{
        //return illustration.tags.includes(this.searchFilter[0])
        return this.searchFilter.every(val => illustration.tags.includes(val))
      })}
      else{
        this.currIllustrations = this.illustrations
      }

    },
    setFocusedIllustration(img){
      this.currFocus = img.link;
      this.currFocusTags = img.tags;
      // console.log(img);
    },
    resetFocusedIllustration(){
      this.currFocus = '';
    }

  },
  created(){
    this.getIllustrations()
  }
}
</script>

<style>
a{
  color: inherit;
  text-decoration: none;
}

#tagFilterGroup{
  display: flex;
  color: #ffffff;
}

.Gallery{
  margin-right: auto;
  margin-left: auto;
  margin-top: 25px;
  display: inline-block;
  padding: 5%;
	/*justify-content: center;
	align-items: center;*/
  background: url('../assets/paper_texture.png')no-repeat center center; 
  background-size: 100% 100%;
  width: 100%;
}

.zoomedModal{
  padding: 5%;
  background: url('../assets/paper_texture.png')no-repeat center center; 
  background-size: 100% 100%;
  width: 100%;
  background-color: transparent !important;
}

#modal-zoomImage___BV_modal_content_{
  background-color: transparent;
  border: none;
  max-width: 95vw;
  max-height: 95vh;
}

#modal-zoomImage > .modal-dialog{
  max-width: 70vw;
}

.zoomImgContainer{
  padding-top: 5%;
  padding-left: 5%;
  padding-right: 5%;
}

.zoomedImg{
  width: 100%;
  height: 100%;
}

.taglist{  
  font-family: KnightsQuest, Avenir, Helvetica, Arial, sans-serif;
  color: #ffffff;
  font-size: 1.5vw;
}

/*
#app {
  padding:auto !important;
}

.galleryImg { 
    width: 40%; 
    height: auto; 
    border-radius: 12px; 
}*/


#photos {
   /* Prevent vertical gaps */
   line-height: 0;
   
   -webkit-column-count: 3;
   -webkit-column-gap:   0px;
   -moz-column-count:    3;
   -moz-column-gap:      0px;
   column-count:         3;
   column-gap:           0px;
}

#photos .container {
  /* Just in case there are inline attributes */
  padding: 5px;
}

#photos .container .galleryImg{
  width: 100% !important;
  height: auto !important;
}

#photos .container .galleryImg:focus{
  outline: none;
  box-shadow: none;
}

@media (max-width: 1200px) {
  #photos {
  -moz-column-count:    3;
  -webkit-column-count: 3;
  column-count:         3;
  }
}
@media (max-width: 1000px) {
  #photos {
  -moz-column-count:    2;
  -webkit-column-count: 2;
  column-count:         2;
  }
}
@media (max-width: 500px) {
  #photos {
  -moz-column-count:    1;
  -webkit-column-count: 1;
  column-count:         1;
  }
}
</style>
